import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { formatMoney } from "../config/store";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <h1 className="cart-title">Your Cart</h1>
        <div className="empty-cart">
          <p>Your cart is currently empty.</p>
          <Link to="/" onClick={toTop} className="continue-shopping-btn">
            CONTINUE SHOPPING
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h1 className="cart-title">Your Cart</h1>

      <div className="cart-table-header">
        <div className="header-product"></div>
        <div className="header-price">Price</div>
        <div className="header-quantity">Quantity</div>
        <div className="header-total">Total</div>
      </div>

      <div className="cart-items">
        {cartItems.map((item, index) => {
          const product = getProductById(item.id);
          if (!product) return null;

          const price = parseFloat(product.price.replace(/,/g, ""));
          const total = price * item.quantity;

          return (
            <div className="cart-item" key={index}>
              <div className="item-info">
                <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                  <img
                    src={product.image}
                    alt={product.name}
                    className="item-image"
                  />
                </Link>
                <div className="item-details">
                  <Link
                    to={`/shopDetails/${product.id}`}
                    onClick={toTop}
                    className="item-name"
                  >
                    {product.name}
                  </Link>
                  {(item.size || item.color) && <p className="item-options">{[item.size, item.color].filter(Boolean).join(" · ")}</p>}
                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeFromCart(item.id, item.size, item.color)
                    }
                  >
                    Remove
                  </button>
                </div>
              </div>

              <div className="item-price">{formatMoney(product.price)}</div>

              <div className="item-quantity">
                <div className="quantity-selector">
                  <button
                    onClick={() =>
                      handleUpdateQuantity(
                        item.id,
                        item.size,
                        item.color,
                        item.quantity - 1
                      )
                    }
                  >
                    -
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    onClick={() =>
                      handleUpdateQuantity(
                        item.id,
                        item.size,
                        item.color,
                        item.quantity + 1
                      )
                    }
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="item-total">{formatMoney(total)}</div>
            </div>
          );
        })}
      </div>

      <div className="cart-footer">
        <div className="subtotal-section">
          <span className="subtotal-label">Subtotal</span>
          <span className="subtotal-value">{formatMoney(subtotal)}</span>
        </div>
        <div className="tax-shipping-note">
          Shipping is added at checkout. See{" "}
          <Link onClick={toTop} to="/shipping">
            Shipping
          </Link>{" "}
          information.
        </div>

        <div className="cart-actions-container">
          <div className="action-buttons">
            <div className="top-buttons">
              <Link to="/shop" className="btn btn-outline" onClick={toTop}>
                CONTINUE SHOPPING
              </Link>
            </div>
            <button className="btn btn-primary" onClick={handleCheckout}>
              CONTINUE TO PAYMENT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
